import { TableHeadersType } from "../tableHeadersType";

export const STICKY_LEAD_DIRECTORY_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "COMMENT DETAILS",
    value: "comment_details",
  },
  {
    label: "ACTION",
    value: "action",
  },
];
export const STICKY_FIRST_LEAD_DIRECTORY_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "NAME",
    value: "company_name",
  },
];

export const LEAD_DIRECTORY_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "EMAIL ID",
    value: "client_email",
  },
  {
    label: "CITY",
    value: "city",
  },
  {
    label: "ENTITY TYPE",
    value: "entity",
  },
  {
    label: "BUSINESS NATURE",
    value: "business_nature",
  },
  {
    label: "ATTACHMENTS",
    value: "attachments",
  },
  {
    label: "CLIENT CATEGORY",
    value: "client_category",
  },
  {
    label: "SCOPE OF WORK",
    value: "scope_of_work",
  },
  {
    label: "LEAD RECEIVED",
    value: "lead_received_on",
  },
  {
    label: "LEAD CATEGORY",
    value: "lead_category",
  },
  {
    label: "STAGE",
    value: "stage",
  },
  {
    label: "STATUS",
    value: "status",
  },
  {
    label: "TURNOVER (IN CRORES)",
    value: "turnover_in_crores",
  },
  {
    label: "LEAD ASSIGNED TO",
    value: "assigned_to",
  },
  {
    label: "DUE DATE",
    value: "due_date",
    width:"200px"
  },
  {
    label: "COMMENT BY",
    value: "comment_by",
  },
  {
    label: "Updated By",
    value: "updated_by",
  },
];

export const EMAIL_HISTORY_LEAD = [
  {
    label: "",
    value: "",
    width: "40px",
  },
  {
    label: "Sent To",
    value: "Sent To",
  },
  {
    label: "Sent By",
    value: "Sent By",
  },
  {
    label: "Sent On",
    value: "Sent On",
  },
];

export const AUTOMATION_MAIL_HISTORY = [
  {
    label: "Email Name",
    value: "email_name",
    width: "370px",
  },
  {
    label: "Subject",
    value: "subject",
    width: "370px",
  },
  {
    label: "Sent At",
    value: "sent_at",
    width: "370px",
  },
];

export const ALL_CLIENT_MEET_UP_STATUS = [
  {
    label: "COMPANY NAME",
    value: "company_name",
    width: "150px"
  },
  {
    label: "NAME",
    value: "name",
  },
  {
    label: "LOCATION",
    value: "location",
    width: "200px"
  },
  {
    label: "LEAD ASSIGNED TO",
    value: "lead_assigned_by",
  },
  {
    label: "MEET UP BY",
    value: "meet_up_by",
  },
  {
    label: "MEET UP STATUS",
    value: "meet_up_completed",
  },
  {
    label: "MEETING DATE",
    value: "meeting_time",
    width:"200px"
  },
  {
    label: "UPDATED BY",
    value: "updated_by",
    width:"100px"
  }
];

export const STAGE_THRESHOLD_HEADERS  = [
  {
    label: "Stage Name",
    value: "stage_name",
    width: "370px",
  },
  {
    label: "Threshold Days",
    value: "threshold_days",
  },
  {
    label: "UPDATED BY",
    value: "updated_by",
    width:"100px"
  },
  {
    label: "Action",
    value: "action",
    width: "60px"
  }
];
